var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7f84f6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,38.6l-1.1-1.1,20.7-20.7h-9.4v4h-1.5v-5.5h12.1c.1,0,.2,0,.3,0s.2,0,.2.1l6.2,6.2c1,1,2.1,1.7,3.3,2.3,1.2.6,2.5.9,3.8.9v1.5c-1.5,0-3-.3-4.4-1s-2.7-1.5-3.8-2.6l-2.6-2.7-6.8,6.8,4.2,4.2-10.7,6.2-.8-1.4,8.9-5.1-5.3-5.3s-13.2,13.2-13.2,13.2ZM8,25v-1.5h8v1.5h-8ZM4,18.8v-1.5h8v1.5H4ZM39.2,14.8c-.8,0-1.4-.3-2-.8-.5-.5-.8-1.2-.8-2s.3-1.5.8-2c.5-.5,1.2-.8,2-.8.8,0,1.5.3,2,.8.5.5.8,1.2.8,2s-.3,1.5-.8,2c-.5.5-1.2.8-2,.8ZM8,12.5v-1.5h8v1.5h-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprint);
export default __webpack_public_path__ + "static/media/sprint.1e9ba6b9db596b1bf4e0f26c295c8509.svg";
export { ForwardRef as ReactComponent };